import candidateActions from "./actions";

const initialState = {
  fullCandidateDetails: null,
  candidateTicketList: null,
  uploadDetails: [],
  candidateDetails: [],
  candidateUpdateDetails: [],
  personalDetails:[],
  courseNameForDump:[],
  generatingRowIds: [],
  generatedRows: [],
  downloadUrls:{},
  pendingRows: {},
};

const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
        case candidateActions.SET_PENDING_DUMP: {
      const { rowId, pending } = action.payload;
      return {
        ...state,
        pendingRows: {
          ...state.pendingRows,
          [rowId]: pending
        }
      };
    }
    case candidateActions.SET_FULL_CANDIDATE_DETAILS:
      return {
        ...state,
        fullCandidateDetails: action.payload,
      };
    case candidateActions.SET_SEARCH_CANDIDATE_DETAILS:
      return {
        ...state,
        candidateDetails: action.payload,
      };
    case candidateActions.SET_UPDATE_CANDIDATE_DETAILS:
      return {
        ...state,
        candidateUpdateDetails: action.payload,
      };
    case candidateActions.SET_TICKETS_LIST_BY_CANDIDATE:
      return {
        ...state,
        candidateTicketList: action.payload,
      };
      case candidateActions.SET_PROFILE_PERSONAL_DETAILS:
        return {
          ...state,
          personalDetails: action.payload,
        };
    case candidateActions.SET_DOWNLOAD_DUMP_URL:
      const { rowId, url } = action.payload;
      return {
        ...state,
        downloadUrls: {
          ...state.downloadUrls,
          [rowId]: url,
        },
      }; 
    case candidateActions.SET_UPLOAD_PERSONAL_DETAILS:
      return {
        ...state,
        uploadDetails: action.payload,
      };
      case candidateActions.SET_COURSE_NAME_FOR_DUMP:
      return {
        ...state,
        courseNameForDump: action.payload,
      };
          case candidateActions.GENERATE_DUMP_REQUEST:
      return {
        ...state,
        generatingRowIds: [...new Set([...state.generatingRowIds, action.payload])],
      };

    case candidateActions.GENERATE_DUMP_SUCCESS:
      return {
        ...state,
        generatingRowIds: state.generatingRowIds.filter(id => id !== action.payload),
        generatedRows: [...new Set([...state.generatedRows, action.payload])],
      };

    case candidateActions.GENERATE_DUMP_FAILURE:
      return {
        ...state,
        generatingRowIds: state.generatingRowIds.filter(id => id !== action.payload),
      };
    default:
      return state;
  }
};

export default candidateReducer;
